export default "__VITE_ASSET__DxJxZRNY__"